<template>
  <div class="filter-item">
    <span class="filter-label">{{ label }}</span>
    <span class="filter-content">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
// 筛选区里面所有的筛选项的样式
.filter-item {
  box-sizing: border-box;
  padding: 0 10px 0 0;
  flex: 1;
  // max-width: 340px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  font-size: 0;
  &:last-child {
    padding: 0;
  }
  .filter-label {
    flex: auto 0 0;
    width: auto;
    text-align: left;
    font-size: 14px;
    font-weight: 450;
    color: #333;
    margin-right: 8px;
  }
  .filter-content {
    flex: 1;
    font-size: 14px;
    color: #333;
  }
  // 筛选区样式自定义
  /deep/ {
    .el-input__inner {
      border: none;
      border-radius: 0px;
    }
    .el-range-editor {
      border-radius: 0;
      border: none;
    }
  }
}
</style>